var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.popupContentComponent,{tag:"component",attrs:{"project-element":_vm.projectElement}})
}
var staticRenderFns = []

export { render, staticRenderFns }